import Homelayout from "../Layouts/HomeLayout";
import ReportsLayout from "../Layouts/ReportsLayout";
import AIReports from "../Screens/HomeScreen/AIReports/AIReports";
import Dashboard from "../Screens/HomeScreen/Dashboard";
import Device from "../Screens/HomeScreen/Device";
import MailSettings from "../Screens/HomeScreen/MailSettings";
import Alertreport from "../Screens/HomeScreen/Reports/AlertReport";
import Consumptionreport from "../Screens/HomeScreen/Reports/ConsumptionReport";
import Failureanalysisreports from "../Screens/HomeScreen/Reports/FailureAnalysisReports";
import HistoryReport from "../Screens/HomeScreen/Reports/HistoryReport";
import NotificationReport from "../Screens/HomeScreen/Reports/NotificationReport";
import Readingreport from "../Screens/HomeScreen/Reports/ReadingReport";
import DemoSubscription from "../Screens/HomeScreen/Subscription/Demosubscription";
import Subscription from "../Screens/HomeScreen/Subscription/Subscription";
import Viewuserdevice from "../Screens/HomeScreen/User/ViewUserDevice";
import Userdetails from "../Screens/HomeScreen/UserDetails";
import Viewdevice from "../Screens/HomeScreen/ViewDevice";
import UserProfile from "../Screens/HomeScreen/profile/UserProfile";

export const dashboardRouter = {
  element: <Homelayout />,
  children: [
    {
      path: "dashboard",
      index: true,
      element: <Dashboard />,
    },
    // {
    //   path: "motordashboard",
    //   element: <MotorDashboard dashboardData={""} />,
    // },
    {
      path: "device",
      element: <Device />,
    },

    { path: "/device/viewdevice", element: <Viewdevice /> },

    { path: "/user", element: <Userdetails /> },

    { path: "/subscription", element: <Subscription /> },

    // { path: "/subscription", element: <DemoSubscription /> },

    {
      path: "/user/viewuser",
      element: <Viewuserdevice />,
    },

    {
      path: "/user_profile",
      element: <UserProfile />,
    },
    {
      path: "/mail_settings",
      element: <MailSettings />,
    },

    {
      path: "reports",
      element: <ReportsLayout />,
      children: [
        {
          path: "readingreport",
          element: <Readingreport />,
        },
        {
          path: "consumptionreport",
          element: <Consumptionreport />,
        },
        {
          path: "historyreport",
          element: <HistoryReport />,
        },
        {
          path: "notificationreport",
          element: <NotificationReport />,
        },
        {
          path: "failureanalysisreports",
          element: <Failureanalysisreports />,
        },
        {
          path: "alertreport",
          element: <Alertreport />,
        },
      ],
    },
    {
      path: "/aireports",
      element: <AIReports />,
    },
  ],
};
